/* eslint-disable @typescript-eslint/default-param-last */
import { HIDE_TOAST, SHOW_TOAST } from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { IToastAction } from '../actions/toast.action';

/**
 * Toast reducer
 * @param {IToastState} state - Toast state
 * @param {IToastAction} action - Toast action
 * @returns {IToastState} Toast state
 */
const toastReducer = (state = initialState.toast, action: IToastAction) => {
  switch (action.type) {
    case SHOW_TOAST:
      return { ...state, ...action.payload };
    case HIDE_TOAST:
      return {
        ...state,
        ...initialState.toast,
      };
    default:
      return state;
  }
};

export default toastReducer;
